import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx, nullsafe } from "keautils";
import { validation, formfields } from "kea-react"
 
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

import { FiltroComponent } from "./filtro";

type Entity = models.RutaEntregaDomicilioDto;
type Filtro = models.FiltroRutaEntregaDomicilio;
import { columnas } from "./columns";

const resource = resources.RutaEAD;
interface State { filtro: Filtro };

export class RutaEntregaDomicilioList extends React.PureComponent<{}, State> {
    constructor(props) {
        super(props);
        this.state = { filtro: {} };
    }

    onBorrar = async (x: Entity) => {
        if (await kea.yesno("¿Borrar ruta?", x.Nombre)) {
            await resource.Delete(x.IdRegistro);
        }
    }

    filtro = (state: State) => state.filtro;
    items = createSelectorRx(this.filtro, filtro => observeResource(resource.Query, filtro));
    onEdit = (x: Entity) => history.go(`./${x.IdRegistro}`);
    onAgregar = () => history.go('./new');
    onRegresar = () => history.go('../');

    render() {
        const items = this.items(this.state);
        const cols = columnas(this);
        return (
            <div>
                <kea.Title titulo="Rutas de entrega a domicilio" onRegresar={this.onRegresar}>
                    <kea.AgregarButton onClick={this.onAgregar} />
                </kea.Title>

                <FiltroComponent value={this.state.filtro} onChange={x => this.setState({ filtro: x })} />

                <kea.Grid2 columnas={cols} cookieKey={"RutaEntregaDomicilioListCookieKey"} items={items} />
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./app/features/general/catalogos/items/rutaEAD/list/list.tsx